export type DeepPartial<T> = {
  [P in keyof T]?: DeepPartial<T[P]>;
};
// AppConfig
export interface AppConfig {
  production: boolean;
  logo: string;
  logoSVG: string;
  logoWhiteSVG?: string;
  logoWhite?: string;
  logoHeader?:string;
  logoFooter?:string;

  metadata: {
    title: string;
    subtitle: string;
    description: string;
    keywords: string;
    favicon: string;
  }
  pages: ConfigPages;
  colors: {
    primary: string;
    secondary: string;
    tertiary: string;
    success?: string;
    warning?: string;
    danger?: string;
    info?: string;
    light?: string;
    dark?: string;
    card?: string;
    text?: string;
  };
  fonts: {
    title?: string;
    subtext?: string;
    text?: string;
  };
  styles?: string|null;

  authRedirect:string;

  region: string; // 'sa' SudAmérica - SEATS.IO

  keyEncript: string;
  ivEncript: string;
  yearProyect: string|number|null;

  keyRecaptcha?: string|null;
  validations: {
    required?: string;
    number?: string;
    minlength?: string;
    maxlength?: string;
    min?: string;
    max?: string;
    email?: string;
    default?: string;
  };
  menu: Menu[];
  mobileMenu?: Menu[];
  footerMenu: FooterMenu[];
  swiperBanner?: {desktop: string, mobile: string}[];
  swiperBannerSuccess?: {desktop: string, mobile: string}[];
  terms?: string;
  staticMap: boolean;
  keyMap: string|null;
  authGoogle: boolean;
  authGuest: boolean;
  appleWallet: boolean;
  googleWallet: boolean;
  currency: string;
  gtmId: string|null;
  zendeskKey: string|null;
  facebookPixelKey: string|null;
  bgDarkRoutes: string[];
  bgCustomRoutes: string[];
  underConstruction: ConfigUnderContructionPage|null;
  registerForm: {
    [key: string]: boolean
  };
  formatDecimalAndMillion: {
    thousandsSeparator?: string;
    decimalSeparator?: string;
    autoDecimal?: boolean;
    forceDecimal?: boolean;
    minDecimalPlaces?: number;
    maxDecimalPlaces?: number;
  };
  organizator?: string | null;
  filters: boolean;
}

export interface ConfigUnderContructionPage {
  countdown: {
    date: Date;
    label?: string|null;
    labelFinished?: string|null;
  } | null;
  title: string|null;
  description: string|null;
  image: string|null;
}


export interface ConfigPages {
  login: ConfigAuthPage;
  register: ConfigAuthPage;
  payment: {
    invoiceTitle: string;
    invoiceName: string;
    invoiceType: string;
    invoiceNumber: string;
    email: string;
  };
  general: {
    [key:string]: any;
  };
  paymentSuccess: {
    title: string;
    subtitle: string;
    date: string;
    location: string;
    organizer: string;
    itemsTitle: string;
    paymentMethod: string;
    orderId: string;
    status: string;
    downloadTicket: string;
    backToHome: string;
  };
  search: {
    title: string;
  };
  ticket: {
    buyTickets: string;
    date: string;
    hour: string;
    noDataDates: string;
    duration: string;
    dateTime: string;
    age: string;
    location: string;
    continue: string;
    selectDate: string;
    eventTag: string;
    price: string;
    tabInformation: string;
    tabAddress: string;
    tabMap: string;
  };
  ticketsSaved: {
    title: string;
    tabActive: string;
    tabHistory: string;
    information: string|null;
    noDataActive: string;
    noDataHistory: string;
    tickets: string;
  };
}

export class Menu {
  id!: number;
  path!: string;
  title?: string;
  external?: boolean;
  target?: '_blank' | '_self' | '_parent' | '_top';
  icon?: string;
  iconType?: 'icon' | 'img' | 'mask';
  submenu?: Menu[];
  custom?: boolean;

  constructor(
    id: number,
    path: string,
    title: string,
    external: boolean = false,
    target: '_blank' | '_self' | '_parent' | '_top' = '_self',
    icon?: string,
    iconType: 'icon' | 'img' | 'mask' = 'icon',
    submenu?: Menu[],
    custom?: boolean
  ) {
    this.id = id;
    this.path = path;
    this.title = title;
    this.external = external;
    this.target = target;
    this.icon = icon;
    this.iconType = iconType;
    this.submenu = submenu;
    this.custom = custom;
  }

  static create(data: Partial<Menu>): Menu {
    return new Menu(
      data.id!,
      data.path!,
      data.title!,
      data.external ?? false,
      data.target ?? '_self',
      data.icon,
      data.iconType ?? 'icon',
      data.submenu,
      data.custom
    );
  }
}

export class FooterMenu {
  id!: number;
  title!: string;
  menu!: Menu[];
}

export interface ConfigAuthPage {
  title: string;
  subtitle?: string;
  form: {
    name?: Partial<ConfigFormField>;
    email?: Partial<ConfigFormField>;
    phone?: Partial<ConfigFormField>;
    city?: Partial<ConfigFormField>;
    credential?: Partial<ConfigFormField>;
    password?: Partial<ConfigFormField>;
    repeatPassword?: Partial<ConfigFormField>;
    rememberMe?: Partial<ConfigFormField>;
  };
  forgotPassword?: string;
  submit: string;
  nextAuth?: {
    question: string;
    action: string;
  }
}
export interface ConfigFormField {
  label: string;
  placeholder: string;
  action: string;
}

export interface ConfigFormFieldValidation {
  required: string;
  invalid: string;
}
